import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find-index";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import { mapState } from 'vuex';
import formMixin from '../formMixin';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'NiotaClassicDatasourcesForm',
  mixins: [formMixin],
  props: {},
  data: function data() {
    return {
      fieldsDisabled: {
        server: ['auto_id', 'filesystem', 'webhook'],
        server_rest: ['auto_id', 'filesystem', 'webhook'],
        server_mqtt: ['auto_id', 'filesystem', 'webhook'],
        tcpPort: ['auto_id', 'filesystem', 'webhook'],
        udpPort: ['auto_id', 'filesystem', 'webhook'],
        useTLS: ['auto_id', 'filesystem', 'webhook']
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    isSuperSystemAdmin: function isSuperSystemAdmin() {
      return this.permissions['super.system.manage'];
    },
    statusItems: function statusItems() {
      var _this = this;

      return ['public', 'private'].map(function (s) {
        return {
          text: _this.$i18n_t("NiotaClassic.DataSources.form.status_".concat(s)),
          value: s
        };
      });
    },
    dataSourceButtons: function dataSourceButtons() {
      var _this2 = this;

      return this.formCardButtons.map(function (button) {
        if (button.icon !== 'fas fa-save') {
          return button;
        }

        return _objectSpread(_objectSpread({}, button), {}, {
          valid: _this2.isSuperSystemAdmin === true ? undefined : false
        });
      });
    },
    isFirefly: function isFirefly() {
      if (this.formItem.type === 'firefly' || this.formItem.type === 'firefly_mqtt') {
        return true;
      }

      return false;
    }
  }),
  watch: {},
  created: function created() {
    this.formItem = cloneDeep(this.editedItem);

    if (!this.formItem.properties) {
      this.formItem.properties = {};
    }
  },
  methods: {
    isFieldEnabled: function isFieldEnabled(fieldId) {
      var _this3 = this;

      return this.fieldsDisabled[fieldId].findIndex(function (type) {
        return type === _this3.formItem.type;
      }) < 0;
    },
    updateRequest: function updateRequest() {
      return NiotaClassicApiService.dataSourcesUpdate(this.formItem.id, this.formItem);
    },
    createRequest: function createRequest() {
      return NiotaClassicApiService.dataSourcesCreate(this.formItem);
    },
    uploadImage: function uploadImage(image) {
      var _this4 = this;

      NiotaClassicApiService.uploadImage(image, 'datasource').then(function (data) {
        _this4.formItem.image = data.file;
      }).catch(function (error) {
        // TODO: create toast with error message
        console.error('Error during image upload', error);
      });
    }
  }
};